/**
 * ConfirmDeleteModal — the styled delete confirmation used by Projects AND
 * Opportunities (same rows, same server rules), replacing window.confirm().
 * The server only ever deletes records created in GlobalOps (QL-XXX); older
 * records that were loaded into GlobalOps return 403 - the warning tells the
 * user before they try.
 */
import { Icon } from '../ui/Icon';
import { Modal } from '../ui/Modal';
import { useDataScope } from '../../context/DataScope';

export default function ConfirmDeleteModal({ noun, name, onCancel, onConfirm }) {
  const scope = useDataScope();
  return (
    <Modal title="" onClose={onCancel} width={460}>
      <div style={{ padding: '24px 28px', fontFamily: "'Montserrat', sans-serif" }}>
        <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', marginBottom: 18 }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              background: '#FFEBEE',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Icon name="trash" size={18} color="#B71C1C" />
          </div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 800, color: '#0D0D0D', marginBottom: 4 }}>Delete this {noun}?</div>
            <div style={{ fontSize: 12, color: '#666', lineHeight: 1.5 }}>
              You're about to permanently delete <b style={{ color: '#B71C1C' }}>{name}</b>. This action <b>cannot be undone</b> — quote,
              PO, invoice, and engineer-assignment data will be removed.
            </div>
          </div>
        </div>
        <div
          style={{
            background: '#FFEBEE',
            border: '1px solid #FFCDD2',
            borderRadius: 8,
            padding: '10px 14px',
            marginBottom: 18,
            fontSize: 11.5,
            color: '#B71C1C',
            lineHeight: 1.5,
          }}
        >
          {scope ? (
            <>Deleting a GLOBAL KSA record also deletes its comments, tasks and Doc Hub files.</>
          ) : (
            <>
              <b>Heads-up:</b> only records created in GlobalOps can be deleted. Older records that were loaded into GlobalOps cannot be
              deleted; change their status instead.
            </>
          )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              background: '#fff',
              color: '#555',
              border: '1px solid #E0E0E0',
              padding: '9px 22px',
              borderRadius: 6,
              fontWeight: 600,
              fontSize: 12,
              cursor: 'pointer',
              fontFamily: 'Montserrat',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              background: '#B71C1C',
              color: '#fff',
              border: 'none',
              padding: '9px 22px',
              borderRadius: 6,
              fontWeight: 700,
              fontSize: 12,
              cursor: 'pointer',
              fontFamily: 'Montserrat',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <Icon name="trash" size={12} color="#fff" /> Delete {noun}
          </button>
        </div>
      </div>
    </Modal>
  );
}
